import $ from 'cash-dom'
import { proxy } from '../resources/proxy.ts'

const handleOrderLookup = async (form) => {
  const submitButton = form.find('[type="submit"]')
  const orderNumberField = form.find('#order-number-input')
  const zipCodeField = form.find('#zip-code-input')
  const orderNumberGroup = orderNumberField.closest('.input-group')
  const zipCodeGroup = zipCodeField.closest('.input-group')
  const orderNumberError = orderNumberGroup.find('.input-group-error')
  const zipCodeError = zipCodeGroup.find('.input-group-error')

  submitButton.prop('disabled', true)

  orderNumberGroup.removeClass('input-error')
  zipCodeGroup.removeClass('input-error')
  orderNumberError.addClass('hidden').html('')
  zipCodeError.addClass('hidden').html('')

  const orderNumber = orderNumberField.val().trim()
  const zipCode = zipCodeField.val().trim()

  const formattedOrderNumber = orderNumber.startsWith('PSI')
    ? orderNumber
    : `PSI${orderNumber}`

  try {
    const response = await proxy(
      '/order-lookup',
      {
        orderNumber: formattedOrderNumber,
        zipCode,
      },
      'GET',
      null
    )

    if (response.error) {
      if (response.code === 'order_number') {
        orderNumberGroup.addClass('input-error')
        orderNumberError
          .html(response.message)
          .removeClass('hidden')
          .css({ opacity: 1 })
      } else if (response.code === 'zip_code') {
        zipCodeGroup.addClass('input-error')
        zipCodeError
          .html(response.message)
          .removeClass('hidden')
          .css({ opacity: 1 })
      } else {
        orderNumberError
          .html(response.message || 'Unable to lookup order')
          .removeClass('hidden')
          .css({ opacity: 1 })
      }
    } else if (response.orderStatusUrl) {
      window.location.href = response.orderStatusUrl
    } else {
      orderNumberError
        .html('Order status URL not available')
        .removeClass('hidden')
        .css({ opacity: 1 })
    }
  } catch (error) {
    console.error('Order lookup failed:', error)
    orderNumberError
      .html('Unable to lookup order. Please try again.')
      .removeClass('hidden')
      .css({ opacity: 1 })
  }
}

const revalidatePrefilledFields = () => {
  const orderLookupForm = $('#look-up-form')
  if (orderLookupForm.length === 0) return

  const orderNumberField = orderLookupForm.find('#order-number-input')
  const zipCodeField = orderLookupForm.find('#zip-code-input')

  setTimeout(() => {
    if (orderNumberField.val().trim().length > 0) {
      orderNumberField.trigger('change')
    }
    if (zipCodeField.val().trim().length > 0) {
      zipCodeField.trigger('change')
    }
  }, 100)
}

const initOrderLookup = () => {
  const orderLookupForm = $('#look-up-form')
  if (orderLookupForm.length === 0) return

  revalidatePrefilledFields()

  orderLookupForm.on('submit', async (e) => {
    e.preventDefault()

    const orderNumberValid =
      orderLookupForm
        .find('#order-number-input')
        .closest('.input-group')
        .attr('data-valid') === 'true'
    const zipCodeValid =
      orderLookupForm
        .find('#zip-code-input')
        .closest('.input-group')
        .attr('data-valid') === 'true'

    if (orderNumberValid && zipCodeValid) {
      await handleOrderLookup(orderLookupForm)
    }
  })
}

$(document).ready(() => {
  initOrderLookup()
})

export { initOrderLookup }
